/** Panel dialog / modal — PANEL light/dark (ModernDark surface hiyerarşisi) */

import { PANEL } from "./panelTokens";

export const panelDialogPaperSx = {
  borderRadius: PANEL.radius.dialog,
  bgcolor: PANEL.surface,
  color: PANEL.text.primary,
  backgroundImage: "none",
  border: `1px solid ${PANEL.border}`,
  boxShadow: PANEL.shadow.dialog,
  overflow: "hidden",
  maxHeight: "calc(100dvh - 24px)",
};

export const panelDialogPaperProps = (maxWidth) => ({
  elevation: 0,
  sx: {
    ...panelDialogPaperSx,
    ...(maxWidth ? { maxWidth } : {}),
  },
});

export const panelDialogAccentBarSx = {
  height: 4,
  background: `linear-gradient(90deg, ${PANEL.accent.main}, var(--panel-gradient-end))`,
};

export const panelDialogHeaderSx = {
  px: { xs: 2, sm: 2.5 },
  py: 2,
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: 1.5,
  borderBottom: `1px solid ${PANEL.border}`,
  bgcolor: PANEL.surface,
};

export const panelDialogHeaderMainSx = {
  display: "flex",
  alignItems: "flex-start",
  gap: 1.5,
  minWidth: 0,
};

export const panelDialogHeaderIconWrapSx = {
  width: 44,
  height: 44,
  borderRadius: "12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  bgcolor: PANEL.accent.soft12,
  border: `1px solid ${PANEL.accent.softBorder22}`,
  color: PANEL.accent.text,
  "& .MuiSvgIcon-root": { fontSize: 22 },
};

export const panelDialogHeaderTitleSx = {
  fontWeight: 700,
  fontSize: "1.05rem",
  lineHeight: 1.3,
  color: PANEL.text.primary,
  overflowWrap: "anywhere",
  wordBreak: "break-word",
};

export const panelDialogHeaderSubtitleSx = {
  mt: 0.35,
  fontSize: "0.8125rem",
  lineHeight: 1.45,
  color: PANEL.text.muted,
  overflowWrap: "anywhere",
  wordBreak: "break-word",
};

export const panelDialogCloseButtonSx = {
  width: 36,
  height: 36,
  borderRadius: "10px",
  border: `1px solid ${PANEL.border}`,
  color: PANEL.text.muted,
  flexShrink: 0,
  "&:hover": {
    bgcolor: PANEL.fill.muted,
    color: PANEL.text.primary,
    borderColor: PANEL.fill.hover,
  },
};

/** Dialog gövdesi — paper ile aynı yüzey (pageBg çukuru yok). */
export const panelDialogContentSx = {
  px: { xs: 2, sm: 2.5 },
  py: { xs: 2, sm: 2.5 },
  bgcolor: PANEL.surface,
  color: PANEL.text.body,
  backgroundImage: "none",
  borderTop: "none",
  borderBottom: "none",
  minWidth: 0,
  overflowX: "hidden",
};

export const panelDialogFormPanelSx = {
  p: { xs: 2, sm: 2.25 },
  borderRadius: PANEL.radius.cardMd,
  bgcolor: PANEL.popover,
  border: `1px solid ${PANEL.border}`,
  boxShadow: PANEL.shadow.card,
};

export const panelDialogHintSx = {
  mt: 1.75,
  px: 0.25,
  fontSize: "0.78rem",
  lineHeight: 1.5,
  color: PANEL.text.muted,
};

export const panelDialogActionsSx = {
  px: { xs: 2, sm: 2.5 },
  py: 2,
  gap: 1,
  bgcolor: PANEL.surface,
  borderTop: `1px solid ${PANEL.border}`,
  flexWrap: "wrap",
  "& .MuiButton-root": {
    maxWidth: "100%",
    whiteSpace: "normal",
    textAlign: "center",
    lineHeight: 1.3,
  },
};

export const panelDialogSecondaryButtonSx = {
  textTransform: "none",
  fontWeight: 600,
  color: PANEL.text.body,
  borderRadius: PANEL.radius.input,
  px: 2,
  py: 0.85,
  border: `1px solid ${PANEL.border}`,
  bgcolor: PANEL.surface,
  boxShadow: "none",
  "&:hover": {
    bgcolor: PANEL.fill.muted,
    borderColor: PANEL.fill.hover,
    boxShadow: "none",
  },
};

export const panelDialogPrimaryButtonSx = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: PANEL.radius.input,
  px: 2.5,
  py: 0.85,
  bgcolor: PANEL.accent.main,
  color: PANEL.accent.contrast,
  boxShadow: "none",
  "&:hover": {
    bgcolor: PANEL.accent.hover,
    boxShadow: PANEL.accent.shadow,
  },
  "&.Mui-disabled": {
    bgcolor: PANEL.accent.soft18,
    color: PANEL.text.muted,
  },
};

export const panelDialogVisibilityToggleSx = {
  color: PANEL.text.muted,
  "&:hover": {
    color: PANEL.accent.text,
    bgcolor: PANEL.accent.soft,
  },
};

export const panelDialogDangerAccentBarSx = {
  height: 4,
  background: `linear-gradient(90deg, ${PANEL.danger.main}, ${PANEL.warning.main})`,
};

export const panelDialogDangerIconWrapSx = {
  ...panelDialogHeaderIconWrapSx,
  bgcolor: PANEL.danger.soft,
  border: `1px solid ${PANEL.danger.border}`,
  color: PANEL.danger.text,
};

export const panelDialogDangerButtonSx = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: PANEL.radius.input,
  px: 2.5,
  py: 0.85,
  bgcolor: PANEL.danger.main,
  color: PANEL.accent.contrast,
  boxShadow: "none",
  "&:hover": {
    filter: "brightness(0.92)",
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    bgcolor: PANEL.fill.subtle,
    color: PANEL.text.muted,
  },
};

/** @deprecated tenant* alias */
export const tenantDialogPaperSx = panelDialogPaperSx;
